import { Radio } from 'react-loader-spinner';
import { useQueryClient } from '@tanstack/react-query';

import * as classes from './GlobalConnectionError.module.css';

/**
 * Component that listens for global query pause events.
 */
export const GlobalConnectionError = () => {
  const queryClient = useQueryClient();

  const pausedQueries = queryClient
    .getQueryCache()
    .getAll()
    .filter((query) => query.state.fetchStatus === 'paused');

  const pausedMutations = queryClient
    .getMutationCache()
    .getAll()
    .filter((query) => query.state.isPaused);

  if (!pausedQueries.length && !pausedMutations.length) return null;

  return (
    <div className={classes.container}>
      <Radio width='100' colors={['#fff', '#fff', '#fff']} visible />
      <p>No connection, waiting to reconnect...</p>
    </div>
  );
};
